import React from 'react';
import { MapPin, Phone } from 'lucide-react';

const BranchCard = ({ branch, isExpanded, onToggle }) => {
  return (
    <div className={`bg-white rounded-2xl border `}>
      <div 
        className="p-6 flex justify-between items-start"
        // onClick={onToggle}
      >
        <div>
          <div className="flex items-center gap-2 mb-3">
            {branch.isMain && (
              <span className="px-3 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full">
                Main Office
              </span>
            )}
            <h3 className="text-xl font-semibold text-gray-800">{branch.name}</h3>
          </div>
          <div className="flex items-start gap-3 text-gray-600">
            <MapPin className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" />
            <p className="leading-relaxed">{branch.address}</p>
          </div>
          {/* {branch.phone && 
          <div className="flex items-start gap-3 text-gray-600 mt-1">
            <Phone className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" />
            <p className="leading-relaxed">{branch.phone}</p>
          </div>
          } */}



{/*REDIRECT TO PHONE  */}
{branch.phone && 
  <div className="flex items-start gap-3 text-gray-600 mt-1">
    <Phone className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" />
    <a 
      href={`tel:${branch.phone.replace(/\s+/g, "")}`} 
      className="leading-relaxed  font-medium  hover:text-black duration-150 ease-in-out"
      title="Call for Enquiries And Admissions"
    >
      {branch.phone}
    </a>
  </div>
}


{/*REDIRECT TO PHONE  */}

        </div>
        {/* {isExpanded ? (
          <ChevronUp className="w-6 h-6 text-gray-400" />
        ) : (
          <ChevronDown className="w-6 h-6 text-gray-400" />
        )} */}
      </div>
      
      {/* {isExpanded && (
        <div className="border-t border-gray-100">
          <div className="h-[300px] w-full">
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${encodeURIComponent(branch.address)}&center=${branch.coordinates.lat},${branch.coordinates.lng}&zoom=16`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default BranchCard;